import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-initial-questionnaire',
  templateUrl: './initial-questionnaire.component.html',
  styleUrls: ['./initial-questionnaire.component.css']
})
export class InitialQuestionnaireComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/views/patients/initial-questionnaire.component.ts